import Styles from 'src/components/Styles';
import AVText from 'src/components/elements/AVText';
import {DealDescriberData} from 'src/components/screens/inbox/descriptor/DescriptorType';
import RoundedButton, {ButtonType} from 'src/components/elements/RoundedButton';
import Localized from 'src/constants/AppStrings';
import {View, Image} from 'react-native';

import {createMaterialTopTabNavigator} from '@react-navigation/material-top-tabs';
import {
  filterTypes,
  getTabOptions,
} from 'src/components/screens/inbox/newui/InboxScreenNewUI';
import InboxScreen from 'src/components/screens/inbox/InboxScreen';
import {Icon} from 'react-native-elements';
import AnnouncementScreen from '../newui/AnnounceMentScreen';
import AnnouncementEmpty from '../../../img/svg/inbox/Announcement';

const Tab = createMaterialTopTabNavigator();

export function dealDescDescriptor(props: DealDescriberData): JSX.Element {
  return (
    <AVText
      maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm12}
      style={props.styles.legalese}
      accessibilityLabel={props.deal.legalese}
    >
      {props.deal.legalese}
    </AVText>
  );
}

export function announcemetEmptyIcon(): JSX.Element {
  return <AnnouncementEmpty stroke={'#003349'} />;
}

export function notificationTabscDescriptor(): JSX.Element {
  return (
    <>
      <Tab.Screen
        name={'Announcements'}
        component={AnnouncementScreen}
        options={getTabOptions(Localized.Labels.announcements)}
        initialParams={null}
      />
      <Tab.Screen
        name={'Messages'}
        component={InboxScreen}
        options={getTabOptions(Localized.Labels.messages)}
        initialParams={{...this.props, filterType: filterTypes.all}}
      />
    </>
  );
}
export function getStyleDescriptor(): {
  [index: string]: {[index: string]: number | string};
} {
  return {
    expiration: {
      fontSize: Styles.Fonts.f0,
      marginBottom: Styles.Spacing.m3,
      marginTop: Styles.Spacing.m2,
      textAlign: 'center',
    },
    content: {
      flex: 1,
      padding: Styles.Spacing.m3,
    },
    topRow: {
      alignItems: 'center',
      flexDirection: 'row',
      marginBottom: Styles.Spacing.m3,
    },
  };
}

export function titleDescriptor(props?: DealDescriberData): string {
  return props.deal.promotionText;
}

export function dealIconDescriptor(): JSX.Element {
  return (
    <Icon name={'check-circle'} size={Styles.Heights.h2} color={'#138665'} />
  );
}

export function dealDefaultIconDescriptor(): JSX.Element {
  return (
    <Image
      accessible
      accessibilityLabel={'Default-MenuIcon Image'}
      accessibilityRole="image"
      aria-label="Default-MenuIcon"
      role="img"
      style={{width: 100, height: 100}}
      source={require('src/components/img/CanteenDealDefault.png')}
      resizeMode="cover"
    />
  );
}

export function dealAppliedBtn() {
  return (
    <RoundedButton
      buttonType={ButtonType.action}
      text={Localized.Labels.applied}
      color={'#707070'}
      containerStyle={getDealDetailStyleDescriptor().appliedButton}
      textStyle={getDealDetailStyleDescriptor().appliedButtonText}
      onPress={() => {
        return false;
      }}
    />
  );
}

export function dealApplyBtn(applyDeal: () => void) {
  return (
    <RoundedButton
      buttonType={ButtonType.action}
      text={Localized.Buttons.apply}
      containerStyle={getDealDetailStyleDescriptor().appliedButton}
      textStyle={getDealDetailStyleDescriptor().appliedButtonText}
      onPress={applyDeal}
      color={Styles.Colors.Canteen.darkGreen}
    />
  );
}

export function dealAppliedContainer() {
  const offers = Localized.Labels.offer_already_claimed.split(': ');
  return (
    <View style={getDealDetailStyleDescriptor().alreadyClaimedOffer}>
      {dealIconDescriptor()}
      <AVText style={getDealDetailStyleDescriptor().alreadyClaimedOfferText}>
        <AVText
          style={[
            getDealDetailStyleDescriptor().alreadyClaimedOfferText,
            {fontWeight: 'bold'},
          ]}
        >
          {offers[0] + ': '}
        </AVText>
        {offers[1]}
      </AVText>
    </View>
  );
}

export function dealValidityKey() {
  return Localized.Labels.ends_on;
}

export function backHeaderStyleDescriptor(): {
  [index: string]: number | string;
} {
  return {
    backgroundColor: Styles.white,
  };
}

export function getDealEndDateTime() {
  return null;
}

export function getDealDetailStyleDescriptor(): {
  [index: string]: {[index: string]: number | string};
} {
  return {
    topView: {
      marginTop: Styles.Spacing.m2,
      flexDirection: 'row',
    },
    image: {
      width: 64,
      height: 64,
      borderRadius: Styles.Spacing.m2,
    },
    defaultImageIcon: {
      width: 100,
      height: 100,
      borderRadius: Styles.Spacing.m2,
    },
    dealTitleRow: {
      alignItems: 'center',
      flexDirection: 'row',
      flex: 1,
      marginTop: Styles.Spacing.m1,
      marginLeft: Styles.Spacing.m2,
    },
    iconView: {
      justifyContent: 'center',
      alignItems: 'center',
    },
    redeemLimit: {
      marginTop: Styles.Spacing.m3,
      fontSize: Styles.Fonts.f8,
      fontWeight: '400',
      fontFamily: Styles.FontFamily.robotoRegular,
      alignSelf: 'center',
      color: Styles.lightGray,
    },
    validUntil: {
      fontSize: Styles.Fonts.f1,
      marginTop: 40,
      fontWeight: '400',
      alignSelf: 'center',
      fontFamily: Styles.FontFamily.aeonikRegular,
    },
    alreadyClaimedOffer: {
      marginTop: Styles.Spacing.m3 + Styles.Spacing.m2,
      marginHorizontal: Styles.Spacing.m3,
      padding: Styles.Spacing.m3,
      flex: 1,
      flexDirection: 'row',
      borderRadius: Styles.Spacing.m2,
      backgroundColor: '#409F6826',
    },
    alreadyClaimedOfferText: {
      fontSize: Styles.Fonts.f8,
      alignSelf: 'center',
      flex: 1,
      marginLeft: Styles.Spacing.m2,
      textAlignVertical: 'center',
      fontFamily: Styles.FontFamily.robotoRegular,
    },
    description: {
      fontSize: Styles.Fonts.f1,
      marginTop: Styles.Spacing.m3,
      paddingLeft: Styles.Spacing.m1,
      fontWeight: '400',
      fontFamily: Styles.FontFamily.robotoRegular,
    },
    expiration: {
      fontSize: Styles.Fonts.f8,
      marginTop: Styles.Spacing.m2 + Styles.Spacing.m2,
      fontFamily: Styles.FontFamily.robotoRegular,
    },
    name: {
      color: Styles.black,
      fontWeight: '700',
      fontFamily: Styles.FontFamily.robotoRegular,
      fontSize: Styles.Fonts.f7,
      position: 'absolute',
      justifyContent: 'center',
      width: '100%',
    },
    appliedButton: {
      alignItems: 'center',
    },
    appliedButtonText: {
      color: Styles.white,
      fontSize: Styles.Fonts.f7,
      fontWeight: '700',
      textAlign: 'center',
      fontFamily: Styles.FontFamily.robotoRegular,
    },
    content: {
      paddingVertical: Styles.Spacing.m3,
      paddingHorizontal: Styles.Spacing.m3 + Styles.Spacing.m1,
      flex: 1,
      backgroundColor: Styles.white,
    },
    allReadText: {
      fontSize: Styles.Fonts.f1,
      paddingTop: Styles.Spacing.m1,
      color: Styles.Colors.Canteen.green,
      fontFamily: Styles.FontFamily.robotoRegular,
      fontWeight: '700',
    },
    emptyMessageText: {},
    promoCreditDesc: {
      fontSize: Styles.Fonts.f1,
      marginTop: Styles.Spacing.m2 + Styles.Spacing.m2,
      fontFamily: Styles.FontFamily.robotoRegular,
      paddingHorizontal: Styles.Spacing.m3,
    },
  };
}
export function allReadTextBgColor(): {[index: string]: string} {
  return {
    backgroundColor: '#7fbc0340',
    color: '#003349',
    allReadTextUnderLine: Styles.Colors.Canteen.green,
  };
}

export function dealAppliedBtnIcon() {
  return null;
}
export function notificationReadUnreadColor(): string {
  return '#409F68';
}

export default {
  dealDescDescriptor,
  getStyleDescriptor,
  titleDescriptor,
  dealIconDescriptor,
  dealApplyBtn,
  dealValidityKey,
  dealAppliedBtn,
  dealAppliedBtnIcon,
  dealAppliedContainer,
  getDealDetailStyleDescriptor,
  backHeaderStyleDescriptor,
  getDealEndDateTime,
  dealDefaultIconDescriptor,
  announcemetEmptyIcon,
  notificationTabscDescriptor,
  notificationReadUnreadColor,
  allReadTextBgColor
};
